module.exports = __webpack_public_path__ + "img/home-logo.89e7eb07.png";